import { useState } from 'react'
import { Icon } from '../../ui/Icon'
import type { Story } from './api'

export interface StoryCircleProps {
  story: Pick<Story, 'titleRu' | 'coverUrl' | 'slides'>
  size: number
  /** Сторис видна покупателю — кольцо цвета бренда, как на главной. */
  live?: boolean
}

/**
 * Кружок сторис, каким его видит покупатель: обложка или, без неё, первый
 * слайд. Картинки нет или она не загрузилась — значок, а не пустота.
 */
export function StoryCircle({ story, size, live = false }: StoryCircleProps) {
  const src = story.coverUrl || story.slides[0]?.url || ''
  const [broken, setBroken] = useState('')

  return (
    <span
      className="sto-circle"
      data-live={live || undefined}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      {src && broken !== src ? (
        <img
          src={src}
          alt=""
          loading="lazy"
          onError={() => {
            setBroken(src)
          }}
        />
      ) : (
        <Icon name="i-stories" size={Math.round(size / 2.2)} />
      )}
    </span>
  )
}
